import { useEffect } from "react";
import { Link } from "react-router-dom";

// Kebijakan privasi landhep.id.
//
// Written from what the platform actually does, checked against the code and the
// server on 2026-09-28: which tables hold user data, which third parties receive
// what, what the browser stores, and where the server sits (DigitalOcean sgp1 —
// outside Indonesia, which UU PDP requires us to disclose). Anything that changes
// one of those facts — a new processor, a tracker, a server move, a self-service
// account deletion — must be reflected here, and EFFECTIVE bumped.
//
// Google OAuth requires this URL on the consent screen before the app can be
// published; section 5 is the part their review reads.

const EFFECTIVE = "28 September 2026";
const MAIL = "info@landhep.id";

const SECTIONS = [
  {
    id: "siapa",
    title: "1. Siapa kami",
    body: [
      "Landhep adalah platform analitik lokasi yang dioperasikan oleh PT Nextops Teknologi Indonesia (\"kami\"). Kebijakan ini menjelaskan data pribadi apa yang kami kumpulkan saat Anda memakai landhep.id, untuk apa data itu dipakai, kepada siapa data itu diberikan, dan hak Anda atas data tersebut.",
      "Kebijakan ini disusun dengan mengacu pada Undang-Undang Nomor 27 Tahun 2022 tentang Pelindungan Data Pribadi. Dalam pengertian undang-undang tersebut, kami bertindak sebagai pengendali data pribadi.",
    ],
  },
  {
    id: "data",
    title: "2. Data yang kami kumpulkan",
    list: [
      ["Data akun", "nama, alamat email, kata sandi (hanya disimpan dalam bentuk hash, tidak pernah dalam bentuk asli), dan nama perusahaan bila Anda mengisinya."],
      ["Data dari akun Google", "bila Anda masuk dengan Google: nama, alamat email, dan foto profil. Lihat bagian 5."],
      ["Profil bisnis", "jenis dan kategori usaha, target pelanggan, kelas harga, kota target, dan preferensi lokasi yang Anda isi saat onboarding."],
      ["Lokasi dan laporan", "titik atau sel grid yang Anda analisis, radius yang dipilih, serta hasil laporan (Deep Analysis, Potensi Bisnis, Potensi Iklan) yang dibuat untuk Anda."],
      ["Data yang Anda unggah", "misalnya daftar toko untuk Branch Radar atau daftar aset untuk Skenario, termasuk nama, koordinat, dan catatan yang Anda sertakan."],
      ["Transaksi", "riwayat saldo kredit, pemotongan kredit per laporan, dan kota yang dibuka untuk akun Anda."],
      ["Data teknis", "alamat IP dan jenis peramban (user agent) yang tercatat pada sesi masuk, serta catatan aktivitas di dalam aplikasi, seperti laporan yang dibuka atau diunduh sebagai PDF."],
    ],
  },
  {
    id: "tujuan",
    title: "3. Untuk apa data dipakai",
    list: [
      ["Menjalankan layanan", "membuat akun, memverifikasi saat Anda masuk, menampilkan peta skor dan laporan yang disesuaikan dengan profil bisnis Anda."],
      ["Menghitung dan menagih", "memotong kredit sesuai laporan yang Anda jalankan dan mencatat kota yang aktif."],
      ["Aktivasi dan dukungan", "menghubungi Anda untuk aktivasi akun dan menjawab pertanyaan."],
      ["Keamanan", "mendeteksi dan mencegah penyalahgunaan, termasuk sesi masuk yang mencurigakan."],
      ["Perbaikan layanan", "memahami fitur mana yang dipakai agar layanan dapat diperbaiki."],
    ],
    after: "Kami tidak menjual data pribadi Anda, tidak memakainya untuk iklan, dan tidak memasang pelacak atau analitik pihak ketiga di landhep.id.",
  },
  {
    id: "pihak-ketiga",
    title: "4. Pihak ketiga yang memproses data",
    body: ["Sebagian layanan kami bergantung pada penyedia berikut. Masing-masing hanya menerima data yang dibutuhkan untuk tugasnya:"],
    list: [
      ["Google Maps Platform (Places)", "koordinat titik yang Anda analisis beserta jenis usaha, untuk menemukan kompetitor dan fasilitas di sekitarnya."],
      ["Google Gemini", "fakta lokasi yang sudah dihitung dan profil bisnis Anda, untuk menyusun narasi laporan. Email, kata sandi, dan data transaksi tidak dikirim."],
      ["Google (Sign-In)", "bila Anda memilih masuk dengan Google."],
      ["Mapbox", "peta dasar dimuat langsung oleh peramban Anda dari server Mapbox, sehingga Mapbox menerima alamat IP dan area peta yang ditampilkan."],
      ["BestTime", "bila diaktifkan untuk suatu laporan, koordinat titik untuk memperkirakan jam ramai."],
      ["Google Fonts", "huruf tampilan dimuat dari server Google, sehingga Google menerima alamat IP Anda."],
      ["DigitalOcean", "penyedia server tempat aplikasi dan basis data kami berjalan."],
    ],
    after: "Kami juga dapat mengungkapkan data bila diwajibkan oleh hukum atau perintah otoritas yang berwenang.",
  },
  {
    id: "google",
    title: "5. Data dari akun Google",
    body: [
      "Bila Anda masuk dengan Google, kami hanya meminta izin untuk nama, alamat email, dan foto profil Anda (cakupan openid, email, dan profile). Kami tidak meminta akses ke Gmail, Google Drive, kontak, kalender, atau data Google lainnya.",
      "Data tersebut hanya dipakai untuk membuat dan mengenali akun Landhep Anda serta menampilkan nama dan foto Anda di dalam aplikasi. Data itu tidak dijual, tidak dibagikan kepada pihak lain, dan tidak dipakai untuk iklan. Anda dapat mencabut akses Landhep kapan saja melalui pengaturan keamanan akun Google Anda.",
    ],
  },
  {
    id: "lokasi",
    title: "6. Di mana data disimpan",
    body: [
      "Data disimpan di server DigitalOcean yang berlokasi di Singapura. Artinya, data pribadi Anda ditransfer dan disimpan di luar wilayah Indonesia. Kami memilih penyedia yang menerapkan standar keamanan industri, dan membatasi akses ke server hanya bagi personel yang membutuhkannya.",
      "Seluruh koneksi ke landhep.id dienkripsi dengan HTTPS, dan kata sandi disimpan dalam bentuk hash. Tidak ada sistem yang sepenuhnya kebal, tetapi kami akan memberi tahu Anda dan otoritas terkait bila terjadi kegagalan pelindungan data pribadi, sesuai ketentuan yang berlaku.",
    ],
  },
  {
    id: "cookie",
    title: "7. Cookie dan penyimpanan di peramban",
    body: [
      "Kami memakai satu cookie, landhep_refresh, yang menjaga Anda tetap masuk hingga 30 hari. Cookie ini tidak dapat dibaca oleh skrip di halaman dan hanya dikirim ke server kami.",
      "Aplikasi juga menyimpan beberapa data di penyimpanan lokal peramban Anda (localStorage) agar lebih cepat: token sesi yang berlaku 15 menit, profil bisnis yang aktif, daftar perbandingan lokasi, dan salinan laporan yang pernah Anda buka. Data ini terhapus saat Anda keluar atau membersihkan data situs di peramban.",
      "Kami tidak memakai cookie iklan maupun cookie pelacak pihak ketiga.",
    ],
  },
  {
    id: "retensi",
    title: "8. Berapa lama data disimpan",
    body: [
      "Data akun, profil bisnis, laporan, dan data yang Anda unggah disimpan selama akun Anda aktif. Laporan yang sudah dibeli tetap tersimpan agar dapat Anda buka kembali.",
      "Bila Anda meminta akun dihapus, kami akan menghapus atau menganonimkan data pribadi Anda, kecuali catatan transaksi yang wajib kami simpan untuk keperluan akuntansi dan perpajakan sesuai peraturan perundang-undangan.",
    ],
  },
  {
    id: "hak",
    title: "9. Hak Anda",
    body: ["Sesuai UU Pelindungan Data Pribadi, Anda berhak untuk:"],
    list: [
      ["Mengakses", "mendapatkan informasi dan salinan data pribadi Anda yang kami simpan."],
      ["Memperbaiki", "memperbarui data yang tidak akurat atau tidak lengkap."],
      ["Menghapus", "meminta penghapusan data pribadi dan akun Anda."],
      ["Menarik persetujuan", "atas pemrosesan yang didasarkan pada persetujuan Anda."],
      ["Mengajukan keberatan", "atas pemrosesan tertentu, serta meminta pemrosesan dibatasi atau ditunda."],
      ["Memindahkan", "meminta data Anda dalam format yang umum dipakai."],
    ],
    after: `Untuk menggunakan hak-hak ini, kirim email ke ${MAIL} dari alamat email akun Anda. Kami akan memverifikasi permintaan tersebut dan menanggapinya dalam batas waktu yang ditentukan peraturan perundang-undangan.`,
  },
  {
    id: "anak",
    title: "10. Pengguna di bawah umur",
    body: ["Landhep ditujukan untuk pelaku usaha dan tidak ditujukan bagi orang yang berusia di bawah 18 tahun. Kami tidak dengan sengaja mengumpulkan data pribadi anak."],
  },
  {
    id: "perubahan",
    title: "11. Perubahan kebijakan",
    body: ["Kebijakan ini dapat kami perbarui, misalnya bila kami menambah penyedia layanan atau memindahkan server. Tanggal berlaku di atas akan diubah, dan untuk perubahan yang berarti kami akan memberi tahu Anda melalui email atau pemberitahuan di aplikasi."],
  },
  {
    id: "kontak",
    title: "12. Hubungi kami",
    body: [`Pertanyaan atau permintaan terkait data pribadi dapat dikirim ke ${MAIL}.`],
  },
];

export default function PrivacyPolicy() {
  // The app shell locks the document to the viewport; this page scrolls.
  useEffect(() => {
    const els = [document.documentElement, document.body, document.getElementById("root")];
    els.forEach((el) => { if (el) { el.style.overflow = "auto"; el.style.height = "auto"; } });
    document.title = "Kebijakan Privasi · Landhep";
    return () => {
      els.forEach((el) => { if (el) { el.style.overflow = ""; el.style.height = ""; } });
      document.title = "landhep";
    };
  }, []);

  return (
    <div className="min-h-screen bg-brand-50 text-[#171C1F] antialiased">
      <nav className="border-b border-slate-100 bg-white">
        <div className="mx-auto flex w-full max-w-[860px] items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-2 text-xl font-extrabold tracking-tight text-brand-700"><img src="/landhep-icon.png" alt="" className="h-7 w-7" />Landhep</Link>
          <Link to="/" className="text-sm font-medium text-slate-600 hover:text-brand-700">Kembali ke beranda</Link>
        </div>
      </nav>

      <main className="mx-auto w-full max-w-[860px] px-6 py-14">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-700">Legal</p>
        <h1 className="mt-3 text-4xl font-extrabold">Kebijakan Privasi</h1>
        <p className="mt-3 text-sm text-slate-500">Berlaku sejak {EFFECTIVE}</p>

        <nav aria-label="Daftar isi" className="mt-8 rounded-2xl border border-brand-200/70 bg-white p-6">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Daftar isi</p>
          <ol className="mt-3 grid gap-1.5 text-sm sm:grid-cols-2">
            {SECTIONS.map((s) => (
              <li key={s.id}><a href={`#${s.id}`} className="text-brand-700 hover:underline">{s.title}</a></li>
            ))}
          </ol>
        </nav>

        <div className="mt-10 space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.id} id={s.id} className="scroll-mt-6">
              <h2 className="text-xl font-bold">{s.title}</h2>
              {(s.body || []).map((p, i) => (
                <p key={i} className="mt-3 max-w-[68ch] leading-relaxed text-[#3E4947]">{p}</p>
              ))}
              {s.list && (
                <dl className="mt-4 divide-y divide-slate-200 rounded-xl border border-slate-200 bg-white">
                  {s.list.map(([t, d]) => (
                    <div key={t} className="grid gap-1 px-5 py-3.5 sm:grid-cols-[210px_1fr] sm:gap-4">
                      <dt className="font-semibold">{t}</dt>
                      <dd className="text-sm leading-relaxed text-[#3E4947]">{d}</dd>
                    </div>
                  ))}
                </dl>
              )}
              {s.after && <p className="mt-4 max-w-[68ch] leading-relaxed text-[#3E4947]">{s.after}</p>}
            </section>
          ))}
        </div>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto flex w-full max-w-[860px] flex-wrap items-center justify-between gap-4 px-6 py-8 text-sm text-slate-500">
          <span>© {new Date().getFullYear()} PT Nextops Teknologi Indonesia</span>
          <a href={`mailto:${MAIL}`} className="hover:text-brand-700">{MAIL}</a>
        </div>
      </footer>
    </div>
  );
}
